import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput, FormTextarea } from '@/_components';
import { FormInputUrl } from '@/_containers';

import { type RegistrarFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<RegistrarFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Registrar Name (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="url"
        render={({ field }) => (
          <FormInputUrl formItemClassName="col-span-12 sm:col-span-6" label="URL" {...field} disabled={!isEditable} />
        )}
      />

      <FormField
        control={form.control}
        name="notes"
        render={({ field }) => (
          <FormTextarea formItemClassName="col-span-12" label="Notes" {...field} disabled={!isEditable} />
        )}
      />
    </>
  );
}
